import { render, staticRenderFns } from "./AdminBrandsOutdated.vue?vue&type=template&id=f831d58a&scoped=true&"
import script from "./AdminBrandsOutdated.vue?vue&type=script&lang=js&"
export * from "./AdminBrandsOutdated.vue?vue&type=script&lang=js&"
import style0 from "./AdminBrandsOutdated.vue?vue&type=style&index=0&id=f831d58a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f831d58a",
  null
  
)

export default component.exports